import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";

// 销售
export default {
    path: '/sale',
    component: Layout,
    redirect: '/salesOrder',
    alwaysShow: true,
    meta: {
        title: '销售',
        icon: 'menu_xs',
        modules: [15000]
    },
    children: [
        // 意向单
        {
            path: 'intentOrder',
            redirect: '/sale/intentOrder/index',
            component: routerView,
            meta: {
                title: '意向单',
                modules: [15022]
            },
            children: [
                {
                    path: 'index',
                    name: 'SaleIntentList',
                    component: () => import('@/views/sale/intentOrder/index'),
                    meta: {
                        title: '意向单',
                        icon: 'spot',
                        breadcrumb: false,
                        keepAlive: true,
                        modules: [15022]
                    }
                },
                // 社区地图
                {
                    path: 'add',
                    name: 'SaleIntentAdd',
                    component: () => import('@/views/sale/intentOrder/map'),
                    hidden: true,
                    meta: {
                        title: '新增',
                        activeMenu: '/sale/intentOrder/index',
                        modules: [15022]
                    }
                },
                // 社区地图
                {
                    path: 'edit/:id',
                    name: 'SaleIntentEdit',
                    component: () => import('@/views/sale/intentOrder/map'),
                    hidden: true,
                    meta: {
                        title: '编辑',
                        activeMenu: '/sale/intentOrder/index',
                        modules: [15022]
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'SaleIntentDetail',
                    component: () => import('@/views/sale/intentOrder/detail'),
                    hidden: true,
                    meta: {
                        title: '意向单详情',
                        activeMenu: '/sale/intentOrder/index',
                        modules: [15022]
                    }
                },
                {
                    path: 'smartPut',
                    name: 'IntentSmartPut',
                    hidden: true,
                    component: () => import('@/views/sale/intentOrder/smartPut'),
                    meta: {
                        title: '新增',
                        activeMenu: '/sale/intentOrder/index',
                        modules: [15022]
                    }
                },
                {
                    path: 'smartPutEdit/:id',
                    name: 'IntentSmartPutEdit',
                    component: () => import('@/views/sale/intentOrder/smartPutMap/index'),
                    hidden: true,
                    meta: {
                        title: '编辑',
                        activeMenu: '/sale/intentOrder/index',
                        modules: [15022]
                    }
                },
                {
                    path: 'smartPutMetro',
                    name: 'IntentSmartPutMetro',
                    hidden: true,
                    component: () => import('@/views/sale/intentOrder/smartPut/metro'),
                    meta: {
                        title: '新增',
                        activeMenu: '/sale/intentOrder/index',
                        modules: [15022]
                    }
                },
                {
                    path: 'smartPutMap',
                    name: 'IntentSmartPutMap',
                    hidden: true,
                    component: () => import('@/views/sale/intentOrder/smartPutMap/index'),
                    meta: {
                        title: '新增',
                        activeMenu: '/sale/intentOrder/index',
                        modules: [15022]
                    }
                }
            ]
        },
        // 销售订单
        {
            path: '/salesOrder',
            redirect: '/salesOrder/programManagement',
            component: routerView,
            alwaysShow: true,
            meta: {
                title: '销售订单',
                icon: 'spot',
                modules: [15011]
            },
            children: [
                // 订单管理
                {
                    path: 'programManagement',
                    redirect: '/salesOrder/programManagement/programList',
                    component: routerView,
                    meta: {
                        title: '订单管理',
                        modules: [15020]
                    },
                    children: [
                        {
                            path: 'programList',
                            name: 'ProgramList',
                            component: () => import('@/views/sale/programManagement/index'),
                            meta: {
                                breadcrumb: false,
                                title: '订单管理',
                                keepAlive: true,
                                modules: [15020]
                            }
                        },
                        {
                            path: 'programDetails/:id',
                            name: 'ProgramDetails',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/programDetails'),
                            meta: {
                                title: '订单详情',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020],
                                isDetail: true
                            }
                        },
                        {
                            path: 'orderDesignDetail',
                            name: 'OrderDesignDetail',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/component/orderDesignDetail'),
                            meta: {
                                title: '订单方案详情',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020],
                                isDetail: true
                            }
                        },
                        {
                            path: 'designResult/:id',
                            name: 'ScaleDesignResult',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/designResult'),
                            meta: {
                                title: '方案结果',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020],
                                isDetail: true
                            }
                        },
                        {
                            path: 'addSaleOrder',
                            name: 'AddSaleOrder',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/addOrder'),
                            meta: {
                                title: '新增订单',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020]
                            }
                        },
                        {
                            path: 'addIntentOrder',
                            name: 'AddIntentOrder',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/addOrder'),
                            meta: {
                                title: '新增订单',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020]
                            }
                        },
                        {
                            path: 'intentOrderMap',
                            name: 'intentOrderMap',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/intentOrderMap/index'),
                            meta: {
                                title: '地图下单',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020]
                            }
                        },
                        {
                            path: 'intentEditMap/:id',
                            name: 'intentEditMap',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/intentOrderMap/index'),
                            meta: {
                                title: '地图下单',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020]
                            }
                        },
                        {
                            path: 'orderMap',
                            name: 'orderMap',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/orderMap'),
                            meta: {
                                title: '地图下单',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020]
                            }
                        },
                        {
                            path: 'editMap/:id',
                            name: 'EditOrderMap',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/orderMap'),
                            meta: {
                                title: '地图下单',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020]
                            }
                        },
                        {
                            path: 'baseInfoForm',
                            name: 'BaseInfoForm',
                            hidden: true,
                            component: () => import('@/views/sale/programManagement/baseInfoForm'),
                            meta: {
                                title: '基本信息',
                                activeMenu: '/salesOrder/programManagement/programList',
                                modules: [15020]
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'txBusiness',
            redirect: '/sale/txBusiness/inquireOrder',
            component: routerView,
            alwaysShow: true,
            meta: {
                title: '线上业务',
                icon: 'spot',
                modules: [15109]
            },
            children: [
                // 查款单
                {
                    path: 'inquireOrder',
                    redirect: '/sale/txBusiness/inquireOrder/index',
                    component: routerView,
                    meta: {
                        title: '查款单',
                        modules: [15110]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'InquireList',
                            component: () => import('@/views/sale/txBusiness/inquireOrder/index'),
                            meta: {
                                breadcrumb: false,
                                title: '查款单',
                                keepAlive: true,
                                modules: [15110]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'InquireDetail',
                            component: () => import('@/views/sale/txBusiness/inquireOrder/detail'),
                            hidden: true,
                            meta: {
                                title: '详情',
                                activeMenu: '/sale/txBusiness/inquireOrder/index',
                                modules: [15110],
                                isDetail: true
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'InquireEdit',
                            component: () => import('@/views/sale/txBusiness/inquireOrder/form'),
                            hidden: true,
                            meta: {
                                title: '编辑',
                                activeMenu: '/sale/txBusiness/inquireOrder/index',
                                modules: [15110]
                            }
                        }
                    ]
                },
                // 充值单
                {
                    path: 'chargeOrder',
                    redirect: '/sale/txBusiness/chargeOrder/index',
                    component: routerView,
                    meta: {
                        title: '充值单',
                        modules: [15111]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'ChargeOrderIndex',
                            component: () => import('@/views/sale/txBusiness/chargeOrder/index'),
                            meta: {
                                breadcrumb: false,
                                title: '充值单',
                                keepAlive: true,
                                modules: [15111]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'ChargeOrderDetail',
                            component: () => import('@/views/sale/txBusiness/chargeOrder/detail'),
                            hidden: true,
                            meta: {
                                title: '详情',
                                activeMenu: '/sale/txBusiness/chargeOrder/index',
                                modules: [15111],
                                isDetail: true
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'ChargeOrderEdit',
                            component: () => import('@/views/sale/txBusiness/chargeOrder/form'),
                            hidden: true,
                            meta: {
                                title: '编辑',
                                activeMenu: '/sale/txBusiness/chargeOrder/index',
                                modules: [15111]
                            }
                        }
                    ]
                }
            ]
        },
        // 销售工具箱
        {
            path: 'toolBox',
            component: routerView,
            redirect: '/sale/toolBox/index',
            meta: {
                title: '销售工具箱',
                icon: 'spot',
                modules: [15026]
            },
            children: [
                {
                    path: 'index',
                    name: 'SaleToolBox',
                    component: () => import('@/views/sale/toolBox/index'),
                    meta: {
                        breadcrumb: false,
                        title: '销售工具箱',
                        modules: [15026]
                    }
                },
                {
                    path: 'sparePosition',
                    name: 'SaleSparePosition',
                    hidden: true,
                    component: () => import('@/views/sale/toolBox/sparePosition'),
                    meta: {
                        title: '空余版位查询',
                        activeMenu: '/sale/toolBox/index',
                        modules: [15105]
                    }
                },
                {
                    path: 'customerInquiry',
                    name: 'CustomerInquiry',
                    hidden: true,
                    component: () => import('@/views/sale/toolBox/customerInquiry'),
                    meta: {
                        title: '客户查询方案',
                        activeMenu: '/sale/toolBox/index',
                        modules: [15106]
                    }
                },
                {
                    path: 'exportMap',
                    name: 'ExportMap',
                    hidden: true,
                    component: () => import('@/views/sale/toolBox/exportMap'),
                    meta: {
                        title: '地图导出',
                        activeMenu: '/sale/toolBox/index',
                        modules: [15104]
                    }
                },
                {
                    path: 'publishInfo',
                    name: 'PublishInfo',
                    hidden: true,
                    component: () => import('@/views/sale/toolBox/publishInfo'),
                    meta: {
                        title: '发布情况',
                        activeMenu: '/sale/toolBox/index',
                        modules: [15107]
                    }
                },
                {
                    path: 'commInfo',
                    name: 'CommInfo',
                    hidden: true,
                    component: () => import('@/views/sale/toolBox/commInfo'),
                    meta: {
                        title: '社区投放情况',
                        activeMenu: '/sale/toolBox/index',
                        modules: [15108]
                    }
                },
                {
                    path: 'inquireInfo',
                    name: 'InquireInfo',
                    hidden: true,
                    component: () => import('@/views/sale/toolBox/inquireInfo'),
                    meta: {
                        title: '线上查款统计',
                        activeMenu: '/sale/toolBox/index',
                        modules: [15112]
                    }
                },
                {
                    path: 'onlineChargeStatistics',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/onlineChargeStatistics'),
                    meta: {
                        title: '线上充值情况表',
                        keepAlive: true,
                        activeMenu: '/sale/toolBox/index',
                        modules: [15114]
                    }
                }
            ]
        }
    ]
};
